/**
 * Created by razial on 24.04.2026.
 */

cleverapps.override(cleverapps.EVENTS, {
    CPROMO_AVAILABLE: "cpromo_available",
    CPROMO_SHOWN: "cpromo_shown",
    CPROMO_FIRSTLAUNCH: "cpromo_firstlaunch",
    CPROMO_TUTORIAL: "cpromo_tutorial",
    CPROMO_COMPLETED: "cpromo_completed",
    CPROMO_RECEIVED: "cpromo_received",
    CPROMO_ARRIVE: "cpromo_arrive",
    CPROMO_PAY: "cpromo_pay",
    CPROMO_PRODUCT: "cpromo_product",
    CPROMO_TRY_PLAY: "cpromo_try_play",
    CPROMO_TRY_DISMISS: "cpromo_try_dismiss"
});
